//import { render_sign } from "../functions";

import SignaturePad from "signature_pad";

var ModalTAC = {
    view: function (ctrl, args) {

        return m('div.dm-overlay',
            m("div.dm-table", [
                m("div.dm-cell", [
                    m("div.dm-modal", [
                        m(".bg-primary[style='padding:10px;z-index:1;']", [
                            m("span[id='titleModal']", "Подписать чек-лист"),
                            m("span.pull-right[style='cursor: pointer;']", {
                                onclick: ModalContainerTAC.close
                            }, [
                                m("i.glyphicon.glyphicon-remove"),
                                m.trust('&nbsp;Закрыть')
                            ])
                        ]),
                        [
                            m("div", [
                                m("div[style='margin: 15px 0; padding: 0 15px;']", [
                                    m("div.signature-pad[style='']", [
                                        m("canvas[style='border: 1px solid #000;'][id='canvasSignTotalAccCard']", ""),
                                        m(".row", [
                                            m(".col-xs-6",[
                                                m("button.btn.btn-success.btn-md", {
                                                    id: "yesBtnModalSignTotalAccCard"
                                                }, "Сохранить")
                                            ]),
                                            m(".col-xs-6",[
                                                m("button.btn.btn-info.btn-md", {
                                                    id: "clear_sign",
                                                    onclick: function () {
                                                        var canvas = document.querySelector("#canvasSignTotalAccCard");
                                                        if (canvas !== null) {
                                                            var signaturePad = new SignaturePad(canvas, {
                                                                backgroundColor: 'rgb(255, 255, 255)'
                                                            });
                                                            signaturePad.clear();
                                                        }
                                                    }
                                                }, "Очистить")
                                            ])
                                        ]),
                                        m("script", [
                                            //m.trust(render_sign())
                                        ])
                                    ]),
                                ])
                            ])
                        ]
                    ])
                ])
            ])
        );
    }
};

export var ModalContainerTAC = {
    container: null,
    idElement: null,
    init: function () {
        ModalContainerTAC.container = document.querySelector('#modalSignTotalAccCard');
        if (!ModalContainerTAC.container) {
            ModalContainerTAC.container = document.createElement('div');
            ModalContainerTAC.container.id = 'modalSignTotalAccCard';
            ModalContainerTAC.container.hidden = true;
            document.body.appendChild(ModalContainerTAC.container);

            m.mount(ModalContainerTAC.container, m.component(ModalTAC, {data:  "", type: false, idElement: ""}));
        }
    },
    open: function (title, idElement) {
        ModalContainerTAC.container = document.querySelector('#modalSignTotalAccCard');
        if(typeof(idElement) != "undefined" && idElement !== null)
            ModalContainerTAC.idElement = idElement;
        if(typeof(removeAll) != "undefined" && removeAll !== null)
            ModalContainerTAC.removeAll = removeAll;

        if (ModalContainerTAC.container) {
            if(title){
                document.getElementById("titleModal").innerText = title;
            }
            //document.getElementById("titlemodalSignTotalAccCard").innerText = title;

            ModalContainerTAC.container.hidden = false;
        }
    },
    close: function () {
        let canvas = document.querySelector("#canvasSignTotalAccCard");
        if (canvas !== null) {
            let signaturePad = new SignaturePad(canvas, {
                backgroundColor: 'rgb(255, 255, 255)'
            });
            signaturePad.clear();
        }
        ModalContainerTAC.container.hidden = true;
    }
};
